import script from "./HalloweenView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HalloweenView.vue?vue&type=script&lang=ts&setup=true"

import "./HalloweenView.vue?vue&type=style&index=0&id=7e67b94a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e67b94a"]])

export default __exports__